// extracted by mini-css-extract-plugin
module.exports = {"flex":"ZyForm_flex_1nVId","mlr5":"ZyForm_mlr5_1eCGd","outer":"ZyForm_outer_2ozPp","left":"ZyForm_left_2X8yz","showMoreBtn":"ZyForm_showMoreBtn_3xDD1"};